export default {
  snackbar: state => state.snackbar,
  formData: state => state.formData,
  pixel: state => state.tyPixels,
  userProfile: state => state.userProfile,
  couponData: state => state.couponData,
  otpRequestId: state => state.otpRequestId
};
